import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Turn } from 'src/app/interfaces/turn';
import { TurnService } from 'src/app/services/turn.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-add-edit-turn',
  templateUrl: './add-edit-turn.component.html',
  styleUrls: ['./add-edit-turn.component.css']
})
export class AddEditTurnComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  id: number;
  operacion: string = 'Agregar ';

  constructor(private fb: FormBuilder,
    private _turnService: TurnService,
    private router: Router,
    private toastr: ToastrService,
    private aRouter: ActivatedRoute) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    })
    this.id = Number(aRouter.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {

    if (this.id != 0) {
      // Es editar
      this.operacion = 'Editar ';
      this.getTurn(this.id);
    }
  }

  getTurn(id: number) {
    this.loading = true;
    this._turnService.getTurn(id).subscribe((data: Turn) => {
      this.loading = false;
      this.form.setValue({
        name: data.name,
        description: data.description
      })
    })
  }

  addTurn() {
    /*  console.log(this.form.value.name);
     console.log(this.form.get('name')?.value); */

    const turn: Turn = {
      name: this.form.value.name,
      description: this.form.value.description
    }
    this.loading = true;

    if (this.id !== 0) {
      // Es editar 
      console.log("Editado: "+ turn);
      turn.id = this.id;
      this._turnService.updateTurn(this.id, turn).subscribe(() => {
        this.toastr.info(`El turno ${turn.name} fue actualizado con exito`, 'Turno actualizado');
        this.loading = false;
        this.router.navigate(['/turn']);
      })

    } else {
      // Es agregagar
      console.log("Agregado: "+ turn);
      this._turnService.saveTurn(turn).subscribe(() => {
        this.toastr.success(`El turno ${turn.name} fue registrado con exito`, 'Turno registrado');
        this.loading = false;
        this.router.navigate(['/turn']);
      })
    }
  }
}
